import { SearchPage } from './SearchPage';
export default SearchPage;
export * from './SearchPage';
